import { MarketableMomentModal } from '@driftt/marketable-moment-modal'
import { Button, Div } from '@driftt/tide-core'
import React, { useState } from 'react'

import BarGraph from 'images/bar-graph.svg'
import BotFlow from 'images/bot_flow.svg'
import SweetSVG from 'images/sweet.svg'
import WebBrowser from 'images/web_browser.svg'

import './style.css'

const SLIDES = [
  {
    title: "You're ready to use Drift! See what's in store 👉",
    image: SweetSVG,
  },
  {
    title: 'Create playbooks to qualify leads on your site 24/7',
    image: WebBrowser,
  },
  {
    title: 'Build bot conversations specific to your business',
    image: BotFlow,
  },
  {
    title: 'See how playbooks are doing on your high-traffic pages',
    image: BarGraph,
    hasExternalNext: true,
  },
]

const PlaybooksUserOnboardedModal = () => {
  const [showModal, setShowModal] = useState(
    new URLSearchParams(window.location.search).get('playbook_editor_onboarded')
  )

  const hideModal = () => setShowModal(false)

  const CloseModalButton = () => (
    <Button type="secondary" onClick={hideModal}>
      Lets go!
    </Button>
  )

  return (
    <Div className="playbooks-onboarded-modal">
      <MarketableMomentModal
        isOpen={showModal}
        onChange={hideModal}
        lastStepComponent={CloseModalButton}
        slides={SLIDES}
        type="carousel"
      />
    </Div>
  )
}

export default PlaybooksUserOnboardedModal
